export function formatStr(str: string, ...args: string[]) {
    if (!str) return str;
    for (let index = 0; index < args.length; index++) {
        const element = args[index];
        str = str.replace(`{${index}}`, element);
    }
    return str;

}